import { useCompanySaleCheck } from "context/useCompanySaleCheck";
import { useState } from "react"
import { Link, useParams } from "react-router-dom";
import { UrlPath } from "utility/routes";

const BannerPromoShop = () => {

    const params = useParams();
    const companyId = params.id ?? "";
    const { companySaleCheck } = useCompanySaleCheck();

    if (companyId === "" || companySaleCheck[companyId] === undefined || !companySaleCheck[companyId].allowed)
        return null;


    const showA = Math.random() < 0.5;



    return (<>
        {showA ? <div className="cc-banner-promo cc-banner-promo--alt-1" id="promo-banner-shop-1">
            <Link to={`${UrlPath.Account.WebShopBase}/${companyId}`} className="cc-banner-promo__url">
                <div className="cc-banner-promo__box">
                    <div className="cc-banner-promo__content">
                        <div className="cc-banner-promo__layout">
                            <div>
                                <h2 className="cc-banner-promo__head">Synlighet selger - gjør bedriften mer attraktiv!</h2>
                                <p className="cc-banner-promo__copy">Velg enkle produkter som fremhever din bedrift: Logo, ekstra lenker og beskrivelse av bedriften som tekst og punktliste. </p>
                            </div>
                            <p><span className="cc-banner-promo__cta"><span><span>Se produktene</span>
                                <svg width="16" height="16" fill="currentColor" className="bi bi-arrow-right" viewBox="0 0 16 16">
                                    <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                                </svg>
                            </span></span></p>
                        </div>
                    </div>
                </div>
            </Link>
        </div>
            :
            <div className="cc-banner-promo cc-banner-promo--alt-2" id="promo-banner-shop-2">
                <Link to={`${UrlPath.Account.WebShopBase}/${companyId}`} className="cc-banner-promo__url">
                    <div className="cc-banner-promo__box">
                        <div className="cc-banner-promo__content">
                            <div className="cc-banner-promo__layout">
                                <div>
                                    <h2 className="cc-banner-promo__head">Gi bedriften et løft - på 2 minutter!</h2>
                                    <p className="cc-banner-promo__copy">Oppdater bedriftens profil med logo, beskrivelse og punktliste over varer og tjenester. Gjør det enklere for kundene å finne deg! </p>
                                </div>
                                <p><span className="cc-banner-promo__cta"><span><span>Oppdater nå</span>
                                    <svg width="16" height="16" fill="currentColor" className="bi bi-arrow-right" viewBox="0 0 16 16">
                                        <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                                    </svg>
                                </span></span></p>
                            </div>
                        </div>
                    </div>
                </Link>
            </div>

        }

    </>)


}

export default BannerPromoShop;